import React, { Component, Fragment } from 'react';
import Autosuggest from 'react-autosuggest';
import { withTranslation } from "react-i18next";

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

const renderSuggestion = suggestion => (
    <div>
        {suggestion}
    </div>
);

class InputAddress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.initialAddress ?? '',
            suggestions: [],
            previousSuggestions: [],
            isLoading: false,
            isCorrectlyChosen: props.initialAddress && props.initialAddress !== '',
            inputFocused: false
        };

        this.inputId = props.inputId ?? "address";

        this.isInputTouched = this.isInputTouched.bind(this);

        this.renderInputComponent = this.renderInputComponent.bind(this);
        this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
        this.loadSuggestions = this.loadSuggestions.bind(this);
        this.storeInputReference = this.storeInputReference.bind(this);

        this.loadSuggestionsDebounced = _.debounce(this.loadSuggestions, 300);
    }

    isInputTouched() {
        // there could be cases where input is named using dot notation (works only for 1 level)
        let isNamedWithDot = this.inputId.split('.');

        if (isNamedWithDot.length > 1) {
            if (isNamedWithDot.length > 2) {
                throw "inputId was named using dot notation and can not be deeper than 1 level";
            }

            return (_.has(this.props.formikProps.touched, isNamedWithDot[0]))
                ? (_.has(this.props.formikProps.touched[isNamedWithDot[0]], isNamedWithDot[1])
                    ? this.props.formikProps.touched[isNamedWithDot[0]][isNamedWithDot[1]] 
                    : false
                )
                : false;
        } else {
            return _.has(this.props.formikProps.touched, this.inputId)
                ? this.props.formikProps.touched[this.inputId]
                : false;
        }
    }

    renderInputComponent(inputProps) {
        let isInvalid = this.isInputTouched()
            && !this.state.inputFocused
            && !this.state.isCorrectlyChosen;

        return <div
            className={this.state.isLoading ? 'loading' : (!this.props.formikProps.isSubmiting && this.state.isCorrectlyChosen ? 'correctly-chosen' : '')}
        >
            <input
                {...inputProps}
                className={'form-control pr-5' + (!this.props.formikProps.isSubmiting && !this.state.isLoading && isInvalid ? ' is-invalid' : '')}
                disabled={this.props.formikProps.isSubmitting}
            />
        </div>
    };

    renderSuggestionsContainer({ containerProps, children, query }) {
        return (
            <div {...containerProps}>
                {children}
            </div>
        );
    }

    storeInputReference(autosuggest) {
        if (autosuggest !== null) {
            this.input = autosuggest.input;
        }
    }

    loadSuggestions(value) {
        this.setState({
            isLoading: true
        });

        return axios.get('/api/address_suggestions', { params: { address: this.state.value } })
            .then(
                success => {
                    this.setState({
                        isLoading: false,
                        suggestions: success.data,
                        previousSuggestions: [...this.state.suggestions, ...success.data],
                    });
                },
                error => {
                    this.setState({
                        isLoading: false,
                        suggestions: []
                    });
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    };

    onChange = (event, { newValue }) => {
        let isCorrectlyChosen = _.indexOf(this.state.previousSuggestions, newValue) !== -1;

        this.props.formikProps.setFieldValue(this.inputId, newValue);
        this.props.formikProps.setFieldTouched(this.inputId, true);
        this.props.setAddressCorrect(isCorrectlyChosen);
        this.props.setAddressChanged(true);

        this.setState({
            value: newValue,
            isCorrectlyChosen: isCorrectlyChosen,
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestionsDebounced.cancel;
        this.loadSuggestionsDebounced(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    shouldRenderSuggestions(value, reason) {
        return value.trim().length > 4;
    }

    render() {
        const { value, suggestions, isLoading } = this.state;
        const inputProps = {
            placeholder: this.props.inputPlaceholder ?? this.props.t('forms.input_address.placeholder'),
            value,
            onChange: this.onChange,
            onFocus: () => {
                this.setState({ inputFocused: true })
            },
            onBlur: () => {
                this.setState({ inputFocused: false })
            },
            type: "text",
            id: this.inputId,
            name: this.inputId,
        }
        const status = (
            !isLoading
            && !this.state.isCorrectlyChosen
            && !this.state.inputFocused
            && this.isInputTouched()
        )
            ? this.props.t('forms.input_address.error')
            : '';

        return (
            <Fragment>
                <Autosuggest
                    id={this.inputId}
                    suggestions={suggestions}
                    inputProps={inputProps}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    renderInputComponent={this.renderInputComponent}
                    renderSuggestionsContainer={this.renderSuggestionsContainer}
                    focusInputOnSuggestionClick={true}
                    ref={this.storeInputReference}
                    highlightFirstSuggestion={true}
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                />

                <div className="invalid-feedback definitely-show">{status}</div>
            </Fragment>
        );
    }
}

export default withTranslation()(InputAddress);